/**
 * ロースターの育成計画バッジ (§3-4、user承認済みの3値仕様、2026-09-19)。
 * 「期限超過」「期限間近 (7日以内)」「通常」を JST の当日基準で判定する。
 */

/** JST の「今日」を YYYY-MM-DD で返す (クライアントのローカルTZに関わらずサーバーの asOf と揃える) */
export const todayJst = (): string =>
  new Intl.DateTimeFormat('sv-SE', { timeZone: 'Asia/Tokyo' }).format(new Date());

/** YYYY-MM-DD 文字列に days 日を加算した YYYY-MM-DD を返す (UTC正午起点、日付境界のDST等の影響を避ける) */
const addDays = (dateStr: string, days: number): string => {
  const d = new Date(`${dateStr}T12:00:00Z`);
  d.setUTCDate(d.getUTCDate() + days);
  return d.toISOString().slice(0, 10);
};

export type DevelopmentPlanBadgeState = 'overdue' | 'near' | 'normal';

/** nearestDueDate が無い (期限未設定) 場合も 'normal' として扱う (§1-1: バッジ自体はhasActiveのみで出す) */
export const classifyDevelopmentPlanBadge = (
  nearestDueDate: string | null,
  today: string = todayJst(),
): DevelopmentPlanBadgeState => {
  if (!nearestDueDate) return 'normal';
  if (nearestDueDate < today) return 'overdue';
  if (nearestDueDate <= addDays(today, 7)) return 'near';
  return 'normal';
};
